import { useMutation } from "react-query";
import Axios from "axios";
import { BookingScheduleInterface } from "../../../features/Booking-Form/typings/booking.types";
import { mergeResourceCalendarScheduleResponse } from "../../../features/Schedule/functions/mergeResourceCalendarScheduleResponse";
import { ResourceCalendarScheduleResponseDto } from "../../../features/Schedule/typings/resource-calendar.types";
import type { ResourceCalendarByObjectRequest } from "../../../features/Schedule/utils/resource-booking-schedule.utils";

export type ResourceScheduleByObjectParams = ResourceCalendarByObjectRequest;

export function useRemoteResourceScheduleByBookingObjectMutation() {
  return useMutation({
    mutationFn: async (
      params: ResourceScheduleByObjectParams
    ): Promise<BookingScheduleInterface[]> => {
      const { data } = await Axios.get<ResourceCalendarScheduleResponseDto>(
        "/booking-schedule/by-booking-object",
        { params }
      );
      return mergeResourceCalendarScheduleResponse(data);
    }
  });
}
